import { render, staticRenderFns } from "./NewRetweetModal.vue?vue&type=template&id=fc0c5e46&"
import script from "./NewRetweetModal.vue?vue&type=script&lang=js&"
export * from "./NewRetweetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports